import { PropagateTask } from '../scheduler/PropagateTask';
export class FromArraySource {
    constructor(array) {
        this.array = array;
    }
    run(sink, scheduler) {
        const task = scheduler.asap(new PropagateTask(runArrayTask(this.array, scheduler), void 0, sink));
        return { dispose: () => task.dispose() };
    }
}
function runArrayTask(array, scheduler) {
    return function arrayTask(time, value, sink) {
        array.forEach((x) => sink.event(scheduler.now(), x));
        sink.end(scheduler.now(), void 0);
    };
}
//# sourceMappingURL=fromArray.js.map